import {Component, Inject, OnInit} from '@angular/core';
import {DataARClaimsLogModel} from '../../../../models/accountsReceivable/data-ar-claims-log.model';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ARService} from '../../ar.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Globals} from '../../../../globals';
import {TdoTableSelectionEvent} from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {ARClaimLogEnum} from '../../../../models/enum/ar-claim-log.enum';

@Component({
  selector: 'app-claim-log',
  templateUrl: './claim-log.component.html',
  styleUrls: ['./claim-log.component.scss']
})
export class ClaimLogComponent implements OnInit {

  ARClaimID: string;
  dataClaimLogs: DataARClaimsLogModel[] = [];
  searchPredicate: (data: any, filter: string) => boolean;
  isLoading: boolean = false;

  constructor(    @Inject(MAT_DIALOG_DATA) public data: any,
                  private arService: ARService,
                  private snackBar: MatSnackBar,
                  private dialog: MatDialog,
                  public dialogRef: MatDialogRef<ClaimLogComponent>,
                  public globals: Globals) { }

  async ngOnInit() {

    // set ARClaimID
    if (this.data && this.data.ARClaimID) {
        this.ARClaimID = this.data.ARClaimID;
    }

    // loading ...
    this.isLoading = true;

    // get claim log data
    const promises: any[] = [
      this.arService.getClaimLog(this.ARClaimID).toPromise()
    ];

    const results: any[] = await Promise.all(promises);
    this.dataClaimLogs = results[0];

    this.isLoading = false;
  }

  onRowSelected($event: TdoTableSelectionEvent) {

  }

  closeRef() {
    this.dialogRef.close();
  }

  showMessage(type, message) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 6000,
      verticalPosition: 'top',
    });
  }

  returnARClaimLogEnum(enumARClaimLogID: string) {
    if (enumARClaimLogID === ARClaimLogEnum.DXEncodedClaim) {
      return 'DXC Encoded Claim';
    }
    else if (enumARClaimLogID === ARClaimLogEnum.DXAttachment) {
      return 'DXC Attachment ID';
    }
    else if (enumARClaimLogID === ARClaimLogEnum.Error) {
      return 'Error';
    }
    else if (enumARClaimLogID === ARClaimLogEnum.Trace) {
      return 'Trace Log';
    }
  }
}
